export { default as InstitutionTemplate } from './InstitutionTemplate';
export * from './InstitutionPage.types';
